import React from 'react';
import { Grid } from 'semantic-ui-react';
import './styles.less';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import { FormInputField } from '../../../../../semantic-ui/components/form-input-field';
import { FormSelectField } from '../../../../../semantic-ui/components/form-select-field';
import { CustomRequiredComponent } from '../../../../../semantic-ui/components/custom-required';

export const AutoparkFormView = ({ autoparkCompaniesList, isAutoparkCompaniesListLoading }) => {
	return (
		<Grid className="autopark-form">
			<Grid.Row className="autopark-form__row">
				<Grid.Column width={6} className="autopark-form__column">
					Компания
					<CustomRequiredComponent />
				</Grid.Column>
				<Grid.Column width={7} className="autopark-form__column">
					<Field
						name="tk_id"
						type="text"
						component={FormSelectField}
						autoComplete="off"
						options={autoparkCompaniesList}
						search
						dropdownClassName="static"
						loading={isAutoparkCompaniesListLoading}
						disabled={isAutoparkCompaniesListLoading}
						noResultsMessage="Компании не найдены"
						placeholder="Выберите компанию"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="autopark-form__row">
				<Grid.Column width={6} className="autopark-form__column">
					Название автопарка
				</Grid.Column>
				<Grid.Column width={7} className="autopark-form__column">
					<Field
						name="name"
						type="text"
						component={FormInputField}
						autoComplete="off"
						placeholder="Укажите название автопарка"
					/>
				</Grid.Column>
			</Grid.Row>
		</Grid>
	);
};

AutoparkFormView.propTypes = {
	autoparkCompaniesList: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.number.isRequired,
			value: PropTypes.number.isRequired,
			text: PropTypes.string.isRequired,
		}),
	).isRequired,
	isAutoparkCompaniesListLoading: PropTypes.bool.isRequired,
};
